import React from 'react';
import Text from '../../../../Components/Base/Text/Text';
import useStripe from '../../Hooks/useStripe';
import styles from './CheckStripeSetup.module.scss';
import StripeRegistration from '../StripeRegistration/StripeRegistration';

interface Props {
	children: React.ReactNode | React.ReactNode[];
}

const CheckStripeSetup: React.FC<Props> = ({ children }) => {
	const { isStripeSetupRequested, canSetupStripe } = useStripe();

	if (!isStripeSetupRequested) {
		return children;
	}

	if (canSetupStripe) {
		return <StripeRegistration />;
	}

	return (
		<>
			<Text tx='component.checkStripeSetup.text1' className={styles.text} />
			<Text tx='component.checkStripeSetup.text3' className={styles.textBold} />
		</>
	);
};

export default CheckStripeSetup;
